import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, KeyRound, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { formatAuthError } from "@/lib/authErrors";
import { useSeo } from "@/lib/seo";

export default function ResetPassword() {
    useSeo({ title: "Nuova password | VendiDirect", description: "Imposta una nuova password di accesso.", noindex: true });
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [form, setForm] = useState({ password: "", confirm: "" });
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);
    const [error, setError] = useState("");

    const submit = async (event) => {
        event.preventDefault(); setError("");
        if (form.password !== form.confirm) return setError("Le password non coincidono");
        setBusy(true);
        try {
            await api.post("/auth/reset-password", { token, password: form.password });
            setDone(true);
        } catch (requestError) {
            setError(formatAuthError(requestError?.response?.data?.detail));
        } finally { setBusy(false); }
    };

    return (
        <main data-testid="reset-password-page" className="login-luxury-page">
            <div className="login-luxury-panel">
                <div className="login-luxury-icon">{done ? <CheckCircle2 size={25} /> : <KeyRound size={25} />}</div>
                <h1 data-testid="reset-password-title" className="login-luxury-title text-center">{done ? "Password aggiornata" : "Crea una nuova password"}</h1>
                {done ? (
                    <div data-testid="reset-password-success" className="mt-6 text-center"><p className="login-luxury-subtitle">Tutte le sessioni precedenti sono state chiuse.</p><Link data-testid="reset-password-login-link" to="/login" className="login-submit-button mt-6">Accedi</Link></div>
                ) : token ? (
                    <form data-testid="reset-password-form" onSubmit={submit} className="login-credentials-form">
                        <label className="login-field">Nuova password<input data-testid="reset-password-input" type="password" minLength="8" maxLength="128" autoComplete="new-password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="login-input" placeholder="Almeno 8 caratteri" /></label>
                        <label className="login-field">Conferma password<input data-testid="reset-password-confirm-input" type="password" minLength="8" maxLength="128" autoComplete="new-password" required value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} className="login-input" placeholder="Ripeti la password" /></label>
                        {error && <div data-testid="reset-password-error" className="login-alert login-alert-error">{error}</div>}
                        <button data-testid="reset-password-submit-button" type="submit" disabled={busy} className="login-submit-button">{busy ? <Loader2 className="animate-spin" size={17} /> : <KeyRound size={17} />} Salva nuova password</button>
                    </form>
                ) : <div data-testid="reset-password-missing-token" className="login-alert login-alert-error mt-6">Link di reset mancante o non valido.</div>}
            </div>
        </main>
    );
}